module.exports = __webpack_public_path__ + "static/media/DM.1861988d.svg";